var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import DomTree from './DomTree';
import devToolMixin from '../../../util/devToolMixin';
let DomTreePanel = class DomTreePanel extends Mixins(devToolMixin) {
  handleCompPathChange(e) {
    this.activeCompPath = e.target.value;
  }
  handleSourcePathChange(e) {
    this.activeSourcePath = e.target.value;
  }
  handleClickContainer(e) {
    if (e.target.isEqualNode(this.$refs.domContainerRef)) {
      // 展示一下页面变量？
      // this.activeCompPath = '';
    }
  }
  handleKeyDown(e) {
    if (e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA') return;
    if (e.target.isContentEditable) return;
    if (e.target.getAttribute('role') === 'tablist') return;
    switch (e.keyCode) {
      case 37:
        // 左
        this.selectParent();
        break;
      case 39:
        // 右
        if (this.ultIsContainer) {
          this.bus.$emit('toggleExpand', !this.expandedLUT[this.activeCompPath]);
        }
        break;
      case 40:
        // 下
        if (this.ultIsContainer && this.expandedLUT[this.activeCompPath]) this.selectChild();else this.selectNext();
        break;
      case 38:
        // 上
        this.selectPrev();
        break;
      case 8:
        this.handleDeleteActive();
        break;
    }
  }
  mounted() {
    /**
     * 拖拽的异步逻辑，当dragInfo的from和to都有值的时候再执行sliceComp
     */
    this.$watch(() => this.bus.layoutOpts.dragInfo, val => {
      if (val.fromPath && val.toPath) {
        try {
          var _this$designer, _this$uc;
          const temp = this.activeLayout;
          (_this$designer = this.designer) === null || _this$designer === void 0 || _this$designer.spliceComp(val.fromPath, val.toPath, temp);
          this.activeCompPath = val.toPath;
          this.bus.layoutOpts.dragInfo = {
            fromPath: null,
            toPath: null
          };
          (_this$uc = this.uc) === null || _this$uc === void 0 || _this$uc.notifyPageletsChange(0);
          this.$nextTick(() => {
            this.activeCompPath = val.prevPath || val.toPath;
          });
        } catch (e) {}
      }
    }, {
      deep: true
    });
    /**
     * 在devtool中更改作用域
     */
    this.$watch(() => {
      var _this$bus$scopedSlotS;
      return [this.currentScope.index, (_this$bus$scopedSlotS = this.bus.scopedSlotStack) === null || _this$bus$scopedSlotS === void 0 ? void 0 : _this$bus$scopedSlotS.length];
    }, (newVal, oldVal) => {
      var _this$currentScope$li, _this$designer2;
      const newLength = (newVal === null || newVal === void 0 ? void 0 : newVal[1]) || 0;
      const oldLength = (oldVal === null || oldVal === void 0 ? void 0 : oldVal[1]) || 0;
      switch (newLength - oldLength) {
        case 1:
          this.switchScope();
          return;
        case -1:
          // this.designer?.exitScope();
          return;
        case 0:
          if (!this.currentScope) return;
          if (this.currentScope.index < 0 || this.currentScope.index > ((_this$currentScope$li = this.currentScope.list) === null || _this$currentScope$li === void 0 ? void 0 : _this$currentScope$li.length)) return;
          // 同层的先退出作用域
          (_this$designer2 = this.designer) === null || _this$designer2 === void 0 || _this$designer2.exitScope();
          this.switchScope();
          return;
        default:
          return;
      }
    }, {
      deep: true
    });
    /**
     * 在编辑器下用户双击了一个作用域，dt也要感知到
     * */
    this.$watch(() => {
      var _this$designer3;
      return (_this$designer3 = this.designer) === null || _this$designer3 === void 0 ? void 0 : _this$designer3.scopeStack.length;
    }, (newVal, oldVal) => {
      if (newVal === this.bus.scopedSlotStack.length) return;
      const diff = (newVal || 0) - (oldVal || 0);
      if (diff === 0) return; // 在index的watcher下handler
      if (diff > 0) {
        var _this$designer4;
        const newStack = (_this$designer4 = this.designer) === null || _this$designer4 === void 0 ? void 0 : _this$designer4.scopeStack;
        const newScopeStacks = newStack === null || newStack === void 0 ? void 0 : newStack.slice(oldVal || 0, (oldVal || 0) + diff);
        newScopeStacks.forEach(newScopeStack => {
          const parentRenderer = newScopeStack.parent.renderer;
          const {
            prevCompPath,
            renderer: targetRenderer
          } = newScopeStack;
          const scopeInfo = this.findScopeInfo(parentRenderer, prevCompPath, targetRenderer);
          if (!!scopeInfo) this.$set(this.bus, 'scopedSlotStack', [...this.bus.scopedSlotStack, scopeInfo]);else console.log('not found renderer');
        });
      } else {
        for (let i = diff; i < 0; i++) {
          this.exitScope();
        }
      }
      // if (diff === 1) {
      //   const newStack = this.designer?.scopeStack;
      //   const newScopeStack = newStack?.[newStack?.length - 1];
      //   const parentRenderer = newScopeStack.parent.renderer;
      //   const { prevCompPath, renderer: targetRenderer } = newScopeStack;
      //   const scopeInfo = this.findScopeInfo(parentRenderer, prevCompPath, targetRenderer);
      //   if (!!scopeInfo) this.$set(this.bus, 'scopedSlotStack', [...this.bus.scopedSlotStack, scopeInfo]);
      //   else console.log('not found renderer');
      // } else if (diff === -1) {
      //   this.exitScope();
      // }
    }, {
      immediate: true
    });
  }
  handleCurrentScopedSlotIndexChange(e) {
    const val = +e.target.value - 1;
    this.currentScopedSlotIndex = val > 0 ? val : 1;
  }
  exitScope() {
    var _this$bus$scopedSlotS2;
    if ((_this$bus$scopedSlotS2 = this.bus.scopedSlotStack) !== null && _this$bus$scopedSlotS2 !== void 0 && _this$bus$scopedSlotS2.length) {
      var _this$bus$scopedSlotS3;
      const prevParentPath = this.currentScope.compPath;
      this.$set(this.bus, 'scopedSlotStack', this.bus.scopedSlotStack.slice(0, ((_this$bus$scopedSlotS3 = this.bus.scopedSlotStack) === null || _this$bus$scopedSlotS3 === void 0 ? void 0 : _this$bus$scopedSlotS3.length) - 1));
      // 这里选不回去，暂时通过ultpagelet的监听解决了，可能会有性能问题
      this.$nextTick(() => {
        this.activeCompPath = prevParentPath;
      });
    }
  }
  render() {
    var _this$currentScopedSl, _this$currentScope$li2, _this$ultPagelet;
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-layout-domTree-wrapper"
    }, [h("div", {
      "class": "ucd-devTool-layout-domTree-panel"
    }, [h("div", {
      "class": "ucd-devTool-layout-domTree-container",
      "on": {
        "click": this.handleClickContainer,
        "keydown": this.handleKeyDown
      },
      "ref": "domContainerRef",
      "attrs": {
        "tabindex": "0"
      }
    }, [!!this.bus.scopedSlotStack.length && h("div", {
      "class": "scopedSlot-nav"
    }, [h("div", {
      "style": {
        display: 'flex'
      }
    }, [h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef;
          return ((_this$windowRef = this.windowRef) === null || _this$windowRef === void 0 || (_this$windowRef = _this$windowRef.document) === null || _this$windowRef === void 0 ? void 0 : _this$windowRef.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": "title"
    }, [" \u524D\u4E00\u4E2A\u63D2\u69FD "]), h("a-button", {
      "attrs": {
        "icon": "swap-left"
      },
      "on": {
        "click": () => this.currentScopedSlotIndex -= 1
      }
    })]), h("span", {
      "class": "index-picker"
    }, [h("a-input", {
      "attrs": {
        "value": this.currentScopedSlotIndex + 1
      },
      "on": {
        "change": this.handleCurrentScopedSlotIndexChange
      },
      "style": {
        width: `${((_this$currentScopedSl = this.currentScopedSlotIndex.toString()) === null || _this$currentScopedSl === void 0 ? void 0 : _this$currentScopedSl.length) + 4 || 4}ch`
      }
    }), h("span", [" / ", ((_this$currentScope$li2 = this.currentScope.list) === null || _this$currentScope$li2 === void 0 ? void 0 : _this$currentScope$li2.length) || 0, " "])]), h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef2;
          return ((_this$windowRef2 = this.windowRef) === null || _this$windowRef2 === void 0 || (_this$windowRef2 = _this$windowRef2.document) === null || _this$windowRef2 === void 0 ? void 0 : _this$windowRef2.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": "title"
    }, [" \u540E\u4E00\u4E2A\u63D2\u69FD "]), h("a-button", {
      "attrs": {
        "icon": "swap-right"
      },
      "on": {
        "click": () => this.currentScopedSlotIndex += 1
      }
    })])]), h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef3;
          return ((_this$windowRef3 = this.windowRef) === null || _this$windowRef3 === void 0 || (_this$windowRef3 = _this$windowRef3.document) === null || _this$windowRef3 === void 0 ? void 0 : _this$windowRef3.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": "title"
    }, [" \u8FD4\u56DE\u4E0A\u7EA7\u4F5C\u7528\u57DF "]), h("a-button", {
      "attrs": {
        "icon": "rollback"
      },
      "on": {
        "click": this.exitScope
      }
    })])]), h(DomTree, {
      "attrs": {
        "layout": (_this$ultPagelet = this.ultPagelet) === null || _this$ultPagelet === void 0 ? void 0 : _this$ultPagelet.layout,
        "hide-actions": this.hideActions,
        "fromAside": this.fromAside
      }
    })]), !this.fromAside && h("div", {
      "class": "nav"
    }, [h("a-row", {
      "class": "form-item",
      "attrs": {
        "type": "flex",
        "align": "middle",
        "justify": "space-between"
      }
    }, [h("a-col", {
      "attrs": {
        "span": 5
      }
    }, [" CompPath: "]), h("a-col", {
      "attrs": {
        "span": 19
      }
    }, [h("a-input", {
      "on": {
        "blur": this.handleCompPathChange,
        "pressEnter": this.handleCompPathChange
      },
      "attrs": {
        "placeholder": "选择一个组件节点或输入跳转"
      },
      "ref": "compPathInputRef",
      "model": {
        value: this.activeCompPath,
        callback: $$v => {
          this.activeCompPath = $$v;
        }
      }
    })])]), h("a-row", {
      "class": "form-item",
      "attrs": {
        "type": "flex",
        "align": "middle",
        "justify": "space-between"
      }
    }, [h("a-col", {
      "attrs": {
        "span": 5
      }
    }, [" SourcePath: "]), h("a-col", {
      "attrs": {
        "span": 19
      }
    }, [h("a-input", {
      "on": {
        "blur": this.handleSourcePathChange,
        "pressEnter": this.handleSourcePathChange
      },
      "attrs": {
        "placeholder": "选择一个组件节点或输入跳转"
      },
      "ref": "sourcePathInputRef",
      "model": {
        value: this.activeSourcePath,
        callback: $$v => {
          this.activeSourcePath = $$v;
        }
      }
    })])])])])]);
  }
};
DomTreePanel = __decorate([Component({
  name: 'DomTreePanel',
  props: {
    hideActions: {
      type: Boolean,
      default: false
    },
    fromAside: {
      type: Boolean,
      default: false
    }
  }
})], DomTreePanel);
export default DomTreePanel;